<template>
  <div class="w-100">
    <vz-cargo-general :order-lock="disabled" />
    <div class="vz-individual-order-cargo-mode-cards">
      <vz-cargo-card
        v-for="(item, index) in parcelItems"
        :key="item.key"
        :title="item.label"
        :disabled="isOnlyOne"
        @remove="removeCard(index)"
        @copy="copyCard(index)"
        @update:title="orderStore.orderForm.cargo.parcels.items[index].label = $event"
      >
        <vz-select
          :modelValue="getItemParam('type', index)"
          :items="parcelTypes"
          :no-empty="true"
          :disabled="disabled"
          class="vz-cargo-card-type"
          label="Габариты коробки"
          @update:modelValue="setItemParam('type', index, $event)"
          @change="orderStore.getOrderPriceAction"
        />
        <vz-measure-input
          :modelValue="getItemParam('weight', index)"
          :disabled="disabled"
          label="Вес"
          class="small-width"
          placeholder="0.9"
          big
          measure="кг"
          :max-value="19999"
          :min-value="0.1"
          with-max-notice
          :error-block-style="false"
          @change="onChangeItemParam('weight', index, $event)"
        />
        <vz-measure-input
          :modelValue="getItemParam('count', index)"
          :disabled="disabled"
          label="Кол-во мест такого типа"
          class="small-width vz-cargo-card-place"
          placeholder="1"
          big
          measure="шт"
          :max-value="999"
          :min-value="1"
          :allow-decimal="false"
          with-max-notice
          @change="onChangeItemParam('count', index, $event)"
        />
      </vz-cargo-card>
    </div>
    <vz-cargo-hint />
    <vz-button
      icon-name="plus"
      variant="primary"
      outline
      big
      class="add-card-button"
      :disabled="disabled"
      @click="addCard"
    >
      Добавить
    </vz-button>
  </div>
</template>

<script setup lang="ts">
import {useOrderStore} from '~/stores/order';
import {parcelTypes} from '~/common/objects';
import VzCargoGeneral from '~/components/personal/order/cargo/parts/vz-cargo-general.vue';
import VzCargoCard from '~/components/personal/order/cargo/parts/vz-cargo-card.vue';
import VzCargoHint from '~/components/personal/order/cargo/parts/vz-cargo-hint.vue';
import useOrderCargo from '~/composables/useOrderCargo';

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false
  }
})

const orderStore = useOrderStore()
const {
  items: parcelItems,
  isOnlyOne,
  getItemParam,
  setItemParam,
  addCard,
  copyCard,
  removeCard
} = useOrderCargo('parcels')

function onChangeItemParam(param: string, index: number, value: string) {
  orderStore.orderForm.cargo.parcels.items[index][param] = Number(value)
  orderStore.getOrderPriceAction()
}
</script>
